function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { defineComponent, $prefix, $props, $setup } from "@opentiny/vue-common";
import PcTemplate from "./pc.js";
import MobileTemplate from "./mobile.js";
import MobileFirstTemplate from "./mobile-first.js";
var template = function template2(mode) {
  if ("pc" === (process.env.TINY_MODE || mode)) {
    return PcTemplate;
  }
  if ("mobile" === (process.env.TINY_MODE || mode)) {
    return MobileTemplate;
  }
  if ("mobile-first" === (process.env.TINY_MODE || mode)) {
    return MobileFirstTemplate;
  }
  return PcTemplate;
};
var $constants = {
  FORM_ITEM: "FormItem",
  FORM_CHANGE: "form.change",
  CHECKBOX: $prefix + "Checkbox",
  CHECKBOX_GROUP: "CheckboxGroup"
};
var Checkbox = defineComponent({
  name: $prefix + "Checkbox",
  props: _extends({}, $props, {
    _constants: {
      type: Object,
      default: function _default() {
        return $constants;
      }
    },
    modelValue: {},
    label: {},
    indeterminate: Boolean,
    disabled: Boolean,
    checked: Boolean,
    name: String,
    trueLabel: [String, Number],
    falseLabel: [String, Number],
    /*
     * 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系
     */
    id: String,
    /*
     * 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系
     */
    controls: String,
    border: Boolean,
    size: String,
    text: String,
    validateEvent: {
      type: Boolean,
      default: true
    },
    events: {
      type: Object,
      default: function _default2() {
        return {};
      }
    },
    displayOnly: {
      type: Boolean,
      default: false
    }
  }),
  setup: function setup(props, context) {
    return $setup({
      props,
      context,
      template
    });
  }
});
var version = "2.10.0";
Checkbox.model = {
  prop: "modelValue",
  event: "update:modelValue"
};
Checkbox.install = function(Vue) {
  Vue.component(Checkbox.name, Checkbox);
};
Checkbox.version = version;
export {
  Checkbox as default
};
